import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import "@/index.css";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PublicLayout } from "@/components/PublicLayout";

import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import ListingDetail from "@/pages/ListingDetail";
import Residential from "@/pages/Residential";
import Commercial from "@/pages/Commercial";
import MedicalDental from "@/pages/MedicalDental";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import MortgageCalculator from "@/pages/MortgageCalculator";
import Appointment from "@/pages/Appointment";
import { Blog, BlogDetail } from "@/pages/Blog";

import CRMLogin from "@/pages/crm/CRMLogin";
import Dashboard from "@/pages/crm/Dashboard";
import Leads from "@/pages/crm/Leads";
import Deals from "@/pages/crm/Deals";
import CRMListings from "@/pages/crm/CRMListings";
import CRMAppointments from "@/pages/crm/Appointments";
import Documents from "@/pages/crm/Documents";
import Notifications from "@/pages/crm/Notifications";
import LeadSearch from "@/pages/crm/LeadSearch";
import Outreach from "@/pages/crm/Outreach";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return <div className="min-h-screen bg-navy flex items-center justify-center text-gold">Authenticating…</div>;
  }
  if (!user) return <Navigate to="/crm/login" state={{ from: loc }} replace />;
  return children;
};

const Public = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/listings" element={<Public><Listings /></Public>} />
          <Route path="/listings/:id" element={<Public><ListingDetail /></Public>} />
          <Route path="/residential" element={<Public><Residential /></Public>} />
          <Route path="/commercial" element={<Public><Commercial /></Public>} />
          <Route path="/medical-dental" element={<Public><MedicalDental /></Public>} />
          <Route path="/about" element={<Public><About /></Public>} />
          <Route path="/contact" element={<Public><Contact /></Public>} />
          <Route path="/mortgage-calculator" element={<Public><MortgageCalculator /></Public>} />
          <Route path="/appointment" element={<Public><Appointment /></Public>} />
          <Route path="/blog" element={<Public><Blog /></Public>} />
          <Route path="/blog/:slug" element={<Public><BlogDetail /></Public>} />

          {/* CRM */}
          <Route path="/crm/login" element={<CRMLogin />} />
          <Route path="/crm" element={<Protected><Dashboard /></Protected>} />
          <Route path="/crm/lead-search" element={<Protected><LeadSearch /></Protected>} />
          <Route path="/crm/leads" element={<Protected><Leads /></Protected>} />
          <Route path="/crm/deals" element={<Protected><Deals /></Protected>} />
          <Route path="/crm/listings" element={<Protected><CRMListings /></Protected>} />
          <Route path="/crm/appointments" element={<Protected><CRMAppointments /></Protected>} />
          <Route path="/crm/outreach" element={<Protected><Outreach /></Protected>} />
          <Route path="/crm/documents" element={<Protected><Documents /></Protected>} />
          <Route path="/crm/notifications" element={<Protected><Notifications /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
